import React, { useState, useEffect } from "react";
import { API_URL } from "../../utils/Apiconfig";
import {
  ChevronRight,
  ChevronDown,
  Folder as FolderIcon,
} from "lucide-react";
import Alert from "../../utils/Alerts";
const Movefile = ({ onClose, fileId, fetchFiles, showAlert,selecteditfolder }) => {
  const [folders, setFolders] = useState([]);
  const [folderMap, setFolderMap] = useState({});
  const [folderPath, setFolderPath] = useState([]);
  const [selectedFolderId, setSelectedFolderId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [alert, setAlert] = useState(null);



  useEffect(() => {
    const el = document.getElementById("folder-path-scroll");
    if (el) el.scrollLeft = el.scrollWidth;
  }, [folderPath]);
  
  useEffect(() => {
    console.log("Movefile component mounted",selecteditfolder);
    const fetchFolders = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(`${API_URL}/api/get-folders-with-subfolders`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) throw new Error("Failed to fetch folders");
        const data = await response.json();

        // Flatten folders into a map
        const map = {};
        const flatten = (items) => {
          items.forEach((f) => {
            map[f._id] = f;
            if (f.subfolders?.length) flatten(f.subfolders);
          });
        };
        flatten(data);
        setFolderMap(map);
        setFolders(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchFolders();
  }, []);

  const getCurrentFolders = () => {
    if (folderPath.length === 0) return folders;
    const last = folderPath[folderPath.length - 1];
    return folderMap[last]?.subfolders || [];
  };

  const handleFolderClick = (folder) => {
    setFolderPath([...folderPath, folder._id]);
    setSelectedFolderId(folder._id);
  };

  const handleBack = () => {
    const newPath = [...folderPath];
    newPath.pop();
    setFolderPath(newPath);
    setSelectedFolderId(newPath[newPath.length - 1] || null);
  };

  const getFolderNamePath = () =>
    folderPath.map((id) => folderMap[id]?.folder_name).filter(Boolean).join(" / ");

  const handleMove = async () => {
    if (!selectedFolderId) {
      showAlert("warning", "Select Folder", "Please select a folder to move the file.");
      return;
    }
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_URL}/api/move-file`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ file_id: fileId, folder_id: selectedFolderId }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to move file.");
      }

      showAlert("success", "Success", "File moved successfully.");
      fetchFiles();
      onClose();
    } catch (err) {
      showAlert("error", "Failed", err.message);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-full max-w-md rounded-xl shadow-lg p-6">
        {/* Top bar */}
        <div className="flex justify-between items-center mb-3">
          {folderPath.length > 0 ? (
            <button
              className="text-sm text-blue-600 hover:underline"
              onClick={handleBack}
            >
              ← Back
            </button>
          ) : (
            <span />
          )}

          <button
            className="text-gray-500 text-sm"
            onClick={onClose}
          >
            X
          </button>
        </div>

        <h2 className="text-lg font-semibold text-gray-800 mb-2">Move File</h2>

        {/* Path */}
        <div className="text-sm text-gray-500 mb-4 overflow-x-auto whitespace-nowrap scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
        <div
  id="folder-path-scroll"
  className=" max-w-full overflow-x-auto"
  style={{
    overflowY: "hidden",
    scrollbarWidth: "none", // Firefox
    msOverflowStyle: "none", // IE
  }}
>
  <div
    className="flex items-center text-sm text-gray-700 whitespace-nowrap min-w-max px-1 pb-1"
    style={{
      display: "flex",
    }}
  >
    {folderPath.length === 0 ? (
      <span className="text-gray-500">Root</span>
    ) : (
      folderPath.map((id, index) => (
        <div key={id} className="flex items-center">
          {index > 0 && <span className="mx-1 text-gray-400">›</span>}
          <span className="truncate max-w-[150px]">{folderMap[id]?.folder_name || "..."}</span>
        </div>
      ))
    )}
  </div>
</div>




</div>


        {/* Folder list */}
        <div className="max-h-[300px] overflow-y-auto border border-gray-200 rounded-md p-2 bg-gray-50">
          {loading ? (
            <p className="text-sm text-gray-500">Loading folders...</p>
          ) : error ? (
            <p className="text-sm text-red-500">{error}</p>
          ) : getCurrentFolders().length === 0 ? (
            <p className="text-gray-500 text-sm text-center">No folders found.</p>
          ) : (
            getCurrentFolders().map((folder) => (
              <div
                key={folder._id}
                className={`flex items-center justify-between p-2 rounded-md cursor-pointer hover:bg-gray-100 transition ${
                  selectedFolderId === folder._id ? "bg-blue-50 border border-blue-200" : ""
                }`}
                onClick={() => handleFolderClick(folder)}
              >
                <div className="flex items-center gap-2 w-full">
                  <FolderIcon className="w-5 h-5 text-yellow-400" />
                  <span className="text-sm text-gray-800 truncate">{folder.folder_name}</span>
                </div>
                {folder.subfolders?.length > 0 && (
                  <ChevronRight className="w-4 h-4 text-gray-400" />
                )}
              </div>
            ))
          )}
        </div>

        {/* Action buttons */}
        <div className="mt-6 flex justify-end gap-3">
          <button
            className="px-4 py-2 text-gray-600 bg-gray-100 rounded hover:bg-gray-200 transition"
            onClick={onClose}
          >
            Cancel
            </button>
          {!selecteditfolder?
          <button
            className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700 transition"
            onClick={handleMove}
          >
            Move Here
          </button>
          :
          <button
          className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700 transition"
          onClick={handleMove}
        >
          Select this folder
        </button>
}
        </div>
      </div>
    </div>
  );
};

export default Movefile;
